import React from "react";
import { NavLink } from "react-router-dom";
import LogoutButton from "../../auth/LogoutButton";

import logo from "../../../assets/logo-white.svg";

const AgentBar = () => {
	return (
		<nav className="nav nav-agent">
			<div className="nav-lf">
				<NavLink to="/profile" exact={true}>
					My Profile
				</NavLink>
			</div>
			<NavLink to="/" exact={true}>
				<img src={logo} alt="Real Mate AI" />
			</NavLink>
			<div className="nav-rt">
				<LogoutButton />
			</div>
		</nav>
	);
};

export default AgentBar;
